import { useMemo } from "react";
import { PriceInterface } from "../store/interfaces";
import { useCartStore } from "../store/cart";

export default function usePrice(): PriceInterface {
  const { currency, selectedVariants, selectedQuantities, discountsApplied } = useCartStore();
  const cartPriceCounter = useMemo(() => {
    let amount = 0, oldAmount = 0;
    const cartItems = Object.entries(selectedQuantities);

    for (let [productId, quantity] of cartItems) {
      const price = selectedVariants[productId].price.old_amount ?? selectedVariants[productId].price.amount;
      oldAmount += price * quantity;
      amount += selectedVariants[productId].price.amount * quantity;
    }

    return {
      amount,
      old_amount: oldAmount,
      currency,
    };
  }, [selectedVariants, selectedQuantities, currency]);

  return useMemo(() => {
    if (discountsApplied) {
      return cartPriceCounter;
    }

    return {
      ...cartPriceCounter,
      amount: cartPriceCounter.old_amount,
    };
  }, [cartPriceCounter, discountsApplied]);
}
